import React from "react";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import RestoreIcon from "@material-ui/icons/Restore";
import { recuperarRegistroIncompleto } from "../../../../../data-store/actions/registry-actions";
import { puedeRecuperarse } from "../recuperarRegistroLogic";

export default function RecuperarRegistroButtonDetail(props) {
  const {
    ParticipantDetail,
    ParticipantDetailKey,
    eventDetail,
    atleteAccount,
    userID,
  } = props;
  const dispatch = useDispatch();

  const estado = puedeRecuperarse(ParticipantDetail);

  if (!estado.mostrar) {
    return null;
  }

  function recuperar() {
    const confirmado = window.confirm(
      "¿Recuperar este registro y marcarlo como pagado en efectivo a tu nombre?\n\n" +
        "Se creará un registro NUEVO y completo con estos mismos datos, con fecha de hoy. " +
        'El registro incompleto original quedará visible en la lista, marcado como "recuperado". ' +
        "Esta acción no se puede deshacer."
    );
    if (!confirmado) return;

    dispatch(
      recuperarRegistroIncompleto(
        "evento_" + eventDetail.iDEvento,
        ParticipantDetailKey,
        ParticipantDetail,
        userID,
        atleteAccount
      )
    );
  }

  if (estado.motivo === "ficha-oxxo-vigente") {
    return (
      <div style={{ textAlign: "center" }}>
        <Button variant="contained" disabled startIcon={<RestoreIcon />}>
          Recuperar registro
        </Button>
        <Typography variant="caption" color="textSecondary" component="p">
          Ficha OXXO vigente. Podrá recuperarse a partir del{" "}
          {estado.disponibleDesde.toLocaleString("es-MX")}.
        </Typography>
      </div>
    );
  }

  return (
    <Button
      onClick={recuperar}
      variant="contained"
      color="primary"
      startIcon={<RestoreIcon />}
    >
      Recuperar registro
    </Button>
  );
}
